const ServiceData = {
  STitle: "You SaasLand wherever your business agency",
  Service: [
    {
      id: 1,
      shape: "icon_shape1.png",
      icon: "ti-panel",
      text: "Export Presets",
      description:
        "Why I say old chap that is spiffing bodge, blag pardon me buggered mufty Oxford butty bubble and squeak wind up, brown bread the full monty bloke ruddy.!",
      btn: "Read More",
      bicon: "ti-arrow-right",
    },
    {
      id: 2,
      shape: "icon_shape2.png",
      icon: "ti-layout-grid2",
      text: "Grid and Guides",
      description:
        "Why I say old chap that is spiffing bodge, blag pardon me buggered mufty Oxford butty bubble and squeak wind up, brown bread the full monty bloke ruddy.!",
      btn: "Read More",
      bicon: "ti-arrow-right",
    },
    {
      id: 3,
      shape: "icon_shape3.png",
      icon: "ti-gallery",
      text: "Prototyping",
      description:
        "Why I say old chap that is spiffing bodge, blag pardon me buggered mufty Oxford butty bubble and squeak wind up, brown bread the full monty bloke ruddy.!",
      btn: "Read More",
      bicon: "ti-arrow-right",
    },
    {
      id: 4,
      shape: "icon_shape4.png",
      icon: "ti-fullscreen",
      text: "Pixel Precision",
      description:
        "Why I say old chap that is spiffing bodge, blag pardon me buggered mufty Oxford butty bubble and squeak wind up, brown bread the full monty bloke ruddy.!",
      btn: "Read More",
      bicon: "ti-arrow-right",
    },
  ],
  agtext1: "Why I say old chap that is spiffing bodge, blag pardon.",
  agtext2: "Why I say old chap that is spiffing bodge, blag pardon.",
  agtext3: "Starkers dropped a clanger lurgy is cack excuse my French what.",
  pServiceTitle: "Our Services",
  pServiceDetails:
    "Why I say old chap that is, spiffing jolly good a load of old tosh spend a penny tosser arse over.!",
  PaymentService: [
    {
      id: 1,
      image: "icon4.png",
      title: "Safer",
      description: "Well at public scho cheeky bugger grub burke.",
    },
    {
      id: 2,
      image: "icon7.png",
      title: "Flexible",
      description: "Well at public scho cheeky bugger grub burke.",
    },
    {
      id: 3,
      image: "icon5.png",
      title: "Convinient",
      description: "Well at public scho cheeky bugger grub burke.",
    },
    {
      id: 4,
      image: "icon8.png",
      title: "Protected",
      description: "Well at public scho cheeky bugger grub burke.",
    },
    {
      id: 5,
      image: "icon6.png",
      title: "World wide",
      description: "Well at public scho cheeky bugger grub burke.",
    },
  ],
  domestic_sales: [
    {
      id: "1",
      HRtitles: "New Delhi",
      HRdescription: "Mr. Sandeep Gupta USG International.",
      Hicon: require("../../img/sales/newDelhi.jpg"),
      rclass: "pr_70",
    },
    {
      id: "2",
      HRtitles: "Pune",
      HRdescription: "Mr. P.J. Kale, A.P. Enterprises.",
      Hicon: require("../../img/sales/pune.jpg"),
      rclass: "pl_50 pr_20",
    },
    {
      id: "3",
      HRtitles: "Vadodara",
      HRdescription: "Mr. Rakesh Swadia, RS Engineering.",
      Hicon: require("../../img/sales/vadodara.jpg"), 
      rclass: "pl_70",
    },
  ],
  international_sales: [
    {
      id: "1",
      HRtitles: "Malaysia - Kuala lumpur",
      HRdescription: "Mr.Halim Zainal Abidin, Olio Resources SDN BHD.",
      Hicon: require("../../img/sales/malaysia.jpg"), 
      rclass: "pr_70",
    },
    {
      id: "2",
      HRtitles: "South Korea - Seoul",
      HRdescription: "Mr. Jay Kim, (KHC) KaRam Hynet Corp.",
      Hicon: require("../../img/sales/southKorea.jpg"), 
      rclass: "pl_50 pr_20",
    },
    {
      id: "3",
      HRtitles: "Oman - Muttrah",
      HRdescription:
        "Mr. Krishnakumar .B, Sohar Industrial Supplies & Trading LLC.",
      Hicon: require("../../img/sales/oman.jpg"), 
      rclass: "pl_70",
    },
    {
      id: "4",
      HRtitles: "UAE - Abu Dhabi",
      HRdescription: "Mr. Shamal Rasheed, Hatta Trading & Services Est.",
      Hicon: require("../../img/sales/abudabi.jpg"), 
      rclass: "pr_70",
    },
    {
      id: "5",
      HRtitles: "Vietnam - Hanoi",
      HRdescription:
        "Mr. Nguyen Thanh Dang, Business Promotion & Electrical Technical Services Co. Ltd.",
      Hicon: require("../../img/sales/vietnam.jpg"), 
      rclass: "pl_50 pr_20",
    },
    {
      id: "6",
      HRtitles: "Turkey - Istanbul",
      HRdescription: "Mr. Dimitrios Daniilidis, TOP ENERJI Ltd.",
      Hicon: require("../../img/sales/turkey.jpg"), 
      rclass: "pl_70",
    },
    {
      id: "7",
      HRtitles: "Greece - Athens",
      HRdescription: "Mr. Yannis Panagopoulos, 3D Consultancy Co.",
      Hicon: require("../../img/sales/3dd.jpg"), 
      rclass: "pr_70",
    },
  ],
  rpost: [
    {
      id: "01",
      image: "blog-grid/post_1.jpg",
      ptitle: "Proin gravi nibh velit auctor aliquet aenean.",
      admin: "Admin",
      date: "March 1, 2019",
    },
    {
      id: "02",
      image: "blog-grid/post_2.jpg",
      ptitle: "Proin gravi nibh velit auctor aliquet aenean.",
      admin: "Admin",
      date: "March 10, 2019",
    },
    {
      id: "03",
      image: "blog-grid/post_3.jpg",
      ptitle: "Proin gravi nibh velit auctor aliquet aenean.",
      admin: "Admin",
      date: "jan 10, 2019",
    },
    {
      id: "04",
      image: "blog-grid/post_4.jpg",
      ptitle: "Proin gravi nibh velit auctor aliquet aenean.",
      admin: "Admin",
      date: "March 1, 2019",
    },
  ],
  Blist: [
    {
      id: "01",
      image: "blog-grid/blog_list1.jpg",
      btitle: "Why I say old chap that is, spiffing jolly good.",
      bdescription:
        "Cheeky bugger amongst bugger knees up get stuffed mate what a load of rubbish starkers dropped a clanger say boot, blow off cobblers butty mufty spiffing Eaton the full monty the BBC a, posh chap.",
      pdate: "10",
      Month: "March",
    },
    {
      id: "02",
      image: "blog-grid/blog_list2.jpg",
      btitle: "Why I say old chap that is, spiffing jolly good.",
      bdescription:
        "Cheeky bugger amongst bugger knees up get stuffed mate what a load of rubbish starkers dropped a clanger say boot, blow off cobblers butty mufty spiffing Eaton the full monty the BBC a, posh chap.",
      pdate: "10",
      Month: "June",
    },
    {
      id: "03",
      image: "blog-grid/blog_list3.jpg",
      btitle: "Why I say old chap that is, spiffing jolly good.",
      bdescription:
        "Cheeky bugger amongst bugger knees up get stuffed mate what a load of rubbish starkers dropped a clanger say boot, blow off cobblers butty mufty spiffing Eaton the full monty the BBC a, posh chap.",
      pdate: "10",
      Month: "March",
    },
    {
      id: "04",
      image: "blog-grid/blog_list4.jpg",
      btitle: "Bloke cracking goal the full monty get stuffed mate posh.",
      bdescription:
        "Cheeky bugger amongst bugger knees up get stuffed mate what a load of rubbish starkers dropped a clanger say boot, blow off cobblers butty mufty spiffing Eaton the full monty the BBC a, posh chap.",
      pdate: "01",
      Month: "July",
    },
  ],
  work: [
    {
      id: "01",
      icon: "ti-settings one",
      title: "Premium plugins",
      p: "Oxford jolly good cras bugger down the pub blow off well arse tinkety tonk old fruit William bite your arm off haggle, old it's all gone to pot daft no biggie bog.!",
    },
    {
      id: "02",
      icon: "ti-heart-broken two",
      title: "Premium plugins",
      p: "Oxford jolly good cras bugger down the pub blow off well arse tinkety tonk old fruit William bite your arm off haggle, old it's all gone to pot daft no biggie bog.!",
    },
    {
      id: "03",
      icon: "ti-target  three",
      title: "Live page builder",
      p: "Oxford jolly good cras bugger down the pub blow off well arse tinkety tonk old fruit William bite your arm off haggle, old it's all gone to pot daft no biggie bog.!",
    },
  ],
  safetyHealthEnvironment: {
    title: "Safety, Health & Environment",
    paragraphs: [
      "We shall strive to provide a safe, healthy, clean & ergonomic working environment for our people. We shall prevent the wasteful use of natural resources & be committed to improving the environment, & shall endeavour to offset the effect of climate change in all spheres of our activities.",
      "We, in the process of production & sale of our products & services, shall strive for economic, social & environmental sustainability.",
    ],
  },
  newsLetter: {
    title: "Newsletter",
    files: [
      {
        date: "24th Newsletter (255KB)",
        description: "Isometric Drawings Part-II",
        url: "https://www.pipehangers.in/pdf/Isometric_Drawings_Part_II.pdf",
      },
      {
        date: "24th Newsletter (255KB)",
        description: "Isometric Drawings Part-II",
        url: "https://www.pipehangers.in/pdf/Isometric_Drawings_Part_II.pdf",
      },
      {
        date: "24th Newsletter (255KB)",
        description: "Isometric Drawings Part-II",
        url: "https://www.pipehangers.in/pdf/Isometric_Drawings_Part_II.pdf",
      },
    ],
  },
  pressRelease: {
    title: "Press Release",
    files: [
      {
        date: "24-06-2015",
        description:
          "Mr. R. Chandrasekhar appointed as Vice President Head of Engineering",
        url: "https://www.pipehangers.in/pdf/PHSPressRelease.pdf",
      },
    ],
  },
  products: {
    constantsHangersSupports: {
      title: "Constant Hangers & Supports",
      description: [
        "The Constant load hanger uses the Bell Crank Lever & helical spring mechanism to provide a constant supporting force over its entire travel range.",
        "Frame sizes 1 to 8 provide a max supporting force of 35,000 kgs with total movements upto 750mm.",
      ],
      files: [
        {
          url: "https://www.pipehangers.in/pdf/CONSTANT%20EFFORT%20SUPPORTS.pdf",
          description:
            "For more details about Constant Hangers & Supports (9 MB)",
        },
      ],
      images: [require("../../img/products/constants.jpg")],
    },
    variableHangersSupports: {
      title: "Variable Hangers & Supports",
      description: [
        "The current range of variable supports are designed to function in shrinking space envelopes peculiar to oil rigs, conventional & combined cycle power plants, refineries & nuclear industry.",
        "The arrangement allows the units to be finished with a variety of surface protection coating like zinc silicate, epoxy paints, hot dip galavanizing etc., allowing final assembly without any damage to protective surface finishes.",
        "The available travel ranges are 35mm, 70 mm, 140 mm, 210 mm & 280mm with supporting forces ranging from 3 kgs to 24000 kgs.",
        'For very heavy loads a new range "High Load Variables" have been introduced for supporting upto 40,000 kgs per support point.',
      ],
      files: [
        {
          url: "https://www.pipehangers.in/pdf/VARIABLE%20EFFORT%20SUPPORTS.pdf",
          description:
            "For more details about Variable Hangers & Supports (11 MB)",
        },
      ],
      images: [require("../../img/products/variable.jpg")],
    },
    rigidStruts: {
      title: "Rigid Struts",
      description: [
        "Pipe work can be subjected to transient dynamic loadings when external forces such as safety relief valve blow out, sesimic events occur, water hammer, 2 phase flow etc act on the pipe.",
        "This will manifest as uncontrolled vibrations which can seriously damage pipe work. This can be prevented by use of Rigid Struts & Shock Absorbers.",
      ],
      files: [
        {
          url: "https://www.pipehangers.in/pdf/rigidstruts.pdf",
          description: "For more details about Rigid Struts (8 MB)",
        },
      ],
      images: [require("../../img/products/rigid.jpg")],
    },
    ancillaries: {
      title: "Ancillaries",
      description: [
        "This section covers components which are essential to connect the spring supports to the structural steel & connect pipes to spring supports.",
        "These have been designed on load group basis ensuring complete compatibility of various components chosen from a given load group number.",
        "Typical products are two bolt, three bolt, horizontal clamps & riser clamps for vertical pipes & pipe shoes.  These are manafactured from a wide range of materials like carbon steel, alloy steel (P11, P22, P91), stainless steel operating over a wide range of temperatures & sizes from 15 NB to 1000 NB.",
        "This section also covers miscellaneous standard components design on the load group basis for supporting pipe work such as U - bolts, spherical ballrockers, rod - couplers, hanger rods, turn buckles, weld less forged eyenuts, clevises etc sizes ranging from M8 to M100.",
      ],
      files: [
        {
          url: "https://www.pipehangers.in/pdf/PIPECLAMPS%20ANCILLARIES%20LOAD%20GROUP.pdf",
          description: " For more details about Ancillaries (11 MB)",
        },
      ],
      images: [require("../../img/products/ancillaries.jpg")],
    },
    slideBearings: {
      title: "Slide Bearings",
      description: [
        "Low Friction Bearings are used to ensure a low co-efficient of friction to accommodate horizontal, lateral movements in pipe work by using PTFE, filled PTFE & graphite pads with a mirror polished stainless counter facing plate.",
      ],
      files: [
        {
          url: "https://www.pipehangers.in/pdf/LOW%20FRICTION%20BARINGS.pdf",
          description: "For more details about Slide Bearings (7 MB)",
        },
      ],
      images: [require("../../img/products/slideBearings.jpg")],
    },
    hydraulicSnubbers: {
      title: "Hydraulic Snubbers (Dynamic Restraints)",

      paragraphs: [
        "Hydraulic Snubbers are used to control movement during abnormal conditions such as earthquakes, turbine trips, safety/relief valve closure. Snubbers allow for free thermal movement of a component during regular conditions, but restrain the component in irregular conditions. A hydraulic snubber allows for pipe deflection under normal operating conditions. When subjected to an impulse load, the snubber becomes activated and acts as a restraint in order to restrict pipe movement.",
        "Our snubbers have pressurized hydraulic systems thus allowing their installation in any position and orientation. The fluid level of the suppressors can be easily and accurately verified through the position of the piston rods as they relate to each other.",
        "For more details of Pipe Hangers Hydraulic Snubbers please: contact us.",
      ],
      files: [
        {
          url: "https://www.pipehangers.in/pdf/DYNAMIC%20RESTRAINTS.pdf",
          description: "For more details about Hydraulic Snubbers (8 MB)",
        },
      ],
      images: [require("../../img/products/hydraulicSnubbers.jpg")],
    },
    otherServices: {
      title: "Other Services",

      description: [
        "Survey of existing pipe supports",
        "Inspection at site prior to commissioning",
        "Assist customers with innovative ideas to provide unique solutions",
        "Stress analysis & detail support engineering",
        "Conduct training programs on Hangers & Supports",
      ],

      images: [
        require("../../img/products/otherservices1.jpg"),
        require("../../img/products/otherservices2.jpg"),
      ],
    },
  },
  downloads: {
    catalogue: {
      title: "Pipe Hangers & Supports Catalogue",
      files: [
        {
          date: "Pipe Hangers & Supports complete Catalogue (19 MB)",
          description: "",
          url: "https://www.pipehangers.in/pdf/Catalogue_phspl_new_2020.pdf",
        },
      ],
    },
    qualityPolicy: {
        title: "Quality Policy",
        files: [
          {
            date: "Quality Policy (72 KB)",
            description: "",
            url: "https://www.pipehangers.in/pdf/QC_Policy.pdf",
          },
        ],
      },
      msmedCertificate: {
        title: "MSMED Certificate",
        files: [
          {
            date: "MSMED Certificate Chennai (16 KB)",
            description: "",
            url: "https://www.pipehangers.in/pdf/msmedonline%20certificate%20chennai_new.pdf",
          },
          {
            date: "MSMED Certificate Thanjavur (16 KB)",
            description: "",
            url: "https://www.pipehangers.in/pdf/TJR%20MSMED%20CERTIFICATE%2018032010_new.pdf",
          },
        ],
      },
      isoCertification: {
        title: "ISO Certification (9001 : 2008)",
        files: [
          {
            date: "ISO Certificate (129 KB)",
            description: "",
            url: "https://www.pipehangers.in/pdf/ISO-Certificate-2018.pdf",
          },
        ],
      },
      healthSafetyEnvironment: {
        title: "Health, Safety & Environment (HSE)",
        files: [
          {
            date: "Health, Safety OHSAS 18001 : 2007 Certificate (98 KB)",
            description: "",
            url: "https://www.pipehangers.in/pdf/health_safty.pdf",
          },
          {
            date: "Environment ISO 14001:2004 Certificate (98 KB)",
            description: "",
            url: "https://www.pipehangers.in/pdf/environment.pdf",
          },
        ],
      },
      NTPCConstantLifeCycleTest: {
        title: "National Thermal Power Corporation (NTPC) Constant Life Cycle Test",
        paragraphs : [
            "We have successfully completed the life cycle endurance test on our constant load hanger under the supervision of NTPC.",
            "Conclusion from NTPC report states: ''The constant load hanger does not have any failure till the completion of 10,000 cycles and thus the cycle test requirement for the 25 years of plant operation and specified number of Plant Start up and Shut Down are Met''.",
            "We are the first company in the country to go through this test in detail.",
        ],
        files: [
          {
            date: "NTPC Constant Life Cycle Test Certificate (702 KB)",
            description: "",
            url: "https://www.pipehangers.in/pdf/Life_Cycle_Endurance_Test.pdf",
          },
        ],
      },
      BHELRegistration : {
        title: "BHARAT HEAVY ELECTRICALS LIMITED (BHEL) Registration",
        files: [
          {
            date: "Registration as Permanent Vendor for Constant Load Hangers (328 KB)",
            description: "",
            url: "https://www.pipehangers.in/pdf/BHEL-Chennai-Constants.pdf",
          },
          {
            date: "Registration for Fabrication of Clamps (36 KB)",
            description: "",
            url: "https://www.pipehangers.in/pdf/BHEL-Chennai-Clamps.pdf",
          },
        ],
      },
      engineersIndiaLtdRegistration: {
        title: "Engineers India Limited Registration",
        files: [
          {
            date: "Engineers India Limited Registration Certificate (342 KB)",
            description: "",
            url: "https://www.pipehangers.in/pdf/EIL-%20Enlist-Till-2018.pdf",
          },
        ],
      },
      siteErectionStorage: {
        title: "Site Erection & Storage",
        paragraphs : [
            "Proper erection & commissioning of hangers & supports is vital to the functioning & long term health of the pipe work system.",
            "Improper installation of spring hanger & supports can cause undue stress to develop at \"Terminal\" points leading to failures or repetitive maintenance problems such as leaky gaskets, weld cracks, vibration in rotating equipments etc.",
            "Pipe Hangers & Supports have Erection/Commissioning manuals for all the products including site storage of supports. A copy of the manual is shipped with the containers along with supports & a copy is mailed along with the dispatch documents to ensure that it reaches the field staff.",
            "Over & above, each hanger carries concise erection instructions in the form of stickers & warning labels for unlocking the locked hangers & supports to bring them to the working condition.",
            "We encourage users to download the manuals & use them to ensure the proper functioning of Pipe Hangers & Supports.",
         ],
        files: [
          {
            date: "Erection Manual for Constant Hangers & Supports (844 KB)",
            description: "",
            url: "https://www.pipehangers.in/pdf/Erection%20Manual%20for%20Constant%20pdf.pdf",
          },
          {
            date: "Erection Manual for Variable Hangers & Supports (644 KB)",
            description: "",
            url: "https://www.pipehangers.in/pdf/Erection%20Manual%20for%20Variable.pdf",
          },
          {
            date: "Erection Manual for Rigid Struts (564 KB)",
            description: "",
            url: "https://www.pipehangers.in/pdf/Erection%20Manual%20for%20Rigid%20Struts%20pdf.pdf",
          },
          {
            date: "Site Storage Procedures (28 KB)",
            description: "",
            url: "https://www.pipehangers.in/pdf/SITE%20STORAGE%20MANUAL.PDF",
          },
        ],
      },
      stabilityCertificate: {
        title: "Stability Certificate",
        files: [
          {
            date: "Stability Certificate Chennai (124 KB)",
            description: "",
            url: "https://www.pipehangers.in/pdf/Stability-PGDI.pdf",
          },
          {
            date: "Stability Certificate Thanjavur (1.66 MB)",
            description: "",
            url: "https://www.pipehangers.in/pdf/Stability-Certificate.pdf",
          },
        ],
      },
      airWaterPollutionCertificate: {
        title: "Air & Water Pollution Certificate",
        files: [
          {
            date: "Air pollution certificate Chennai (24.0 KB)",
            description: "",
            url: "https://www.pipehangers.in/pdf/air-chennai.pdf",
          },
          {
            date: "Water pollution certificate Chennai (24.0 KB)",
            description: "",
            url: "https://www.pipehangers.in/pdf/water-chennai.pdf",
          },
          {
            date: "Air pollution certificate Thanjavur (932 KB)",
            description: "",
            url: "https://www.pipehangers.in/pdf/Air%20(1).pdf",
          },
          {
            date: "Water pollution certificate Thanjavur (940 KB)",
            description: "",
            url: "https://www.pipehangers.in/pdf/Water.pdf",
          },
        ],
      },
  },
};
export default ServiceData;
